import BuilderGridFilterBar from './BuilderGridFilterBar';
import { Root, Slide, Carousel, Heading, ClearButton } from './GridFilterBar';

const GridFilterBar = {
  Root,
  Slide,
  Carousel,
  Heading,
  ClearButton,
};

export { GridFilterBar, BuilderGridFilterBar };
